import InterventionTable from "./Table";

const InterventionTab = ({ interventions = [] }) => {
  return (
    <InterventionTable interventions={interventions} />
  );
};

export default InterventionTab;
